<p class="tag tag-secondary">
  {{ (status === HarvestActivityReportStatus.Approved
  ? '::Reasons:Approved'
  : '::Reasons:Rejected') | abpLocalization }}
</p>
